import { Styles } from 'react-jss'
import { NORMALIZE } from './normalize'

export const generateWebUiGlobalStyles = (): Styles => ({
  '@global': {
    ...NORMALIZE,
    // Enable font smoothing for macOS - other OS's handle this by default
    html: {
      '-webkit-font-smoothing': 'antialiased',
      '-moz-osx-font-smoothing': 'grayscale',
    },
  },
})
